const universalTagNamesDataMap = {
  angular: {
    publicName: 'Angular',
    twitterTags: ['angular', 'javascript', 'frontenddev', 'webdev'],
  },
  typescript: {
    publicName: 'TypeScript',
    twitterTags: ['typescript', 'frontenddev', 'webdev'],
  },
  react: {
    publicName: 'React',
    twitterTags: ['reactjs', 'javascript', 'frontenddev', 'webdev'],
  },
  vuejs: {
    publicName: 'Vuejs',
    twitterTags: ['vuejs', 'javascript', 'frontenddev', 'webdev'],
  },
  graphql: {
    publicName: 'GraphQL',
    twitterTags: ['GraphQL', 'javascript', 'frontenddev', 'webdev'],
  },
  nodejs: {
    publicName: 'Nodejs',
    twitterTags: ['nodejs', 'javascript', 'webdev'],
  },
  javascript: {
    publicName: 'JavaScript',
    twitterTags: ['javascript', 'webdev', 'frontenddev'],
  },
  golang: {
    publicName: 'GoLang',
    twitterTags: ['golang'],
  },  
  frontenddev: {
    publicName: 'Front End Development',
    twitterTags: ['frontenddev', 'webdev'],
  },
  web: {
    publicName: 'Web',
    twitterTags: ['Webdev'],
  },
  android: {
    publicName: 'Android',
    twitterTags: ['androiddev', 'mobiledev', ],
  },
  kotlin: {
    publicName: 'Kotlin',
    twitterTags: ['kotlin', 'androiddev', 'mobiledev', 'iosdev', ],
  },
  flutter: {
    publicName: 'Flutter',
    twitterTags: ['flutter', 'flutterdev', 'androiddev', 'mobiledev', 'iosdev', ],
  },  
  graphql: {
    publicName: 'GraphQL',
    twitterTags: ['graphql', 'javascript', 'webdev', 'frontenddev'],
  },


  ux: {
    publicName: 'UX',
    twitterTags: ['ux'],
  },
  php: {
    publicName: 'PHP',
    twitterTags: ['php'],
  },
  docker: {
    publicName: 'Docker',
    twitterTags: ['docker'],
  },
  machinelearning: {
    publicName: 'Machine Learning',
    twitterTags: ['machinelearning', 'datascience', 'ml', 'artificialintelligence'],
  },
  gamedev: {
    publicName: 'Game Dev',
    twitterTags: ['gamedev', 'gamedevelopment'],
  },

  aws: {
    publicName: 'AWS',
    twitterTags: ['aws'],
  },
  python: {
    publicName: 'Python',
    twitterTags: ['python', 'pythondev'],
  },
  java: {
    publicName: 'Java',
    twitterTags: ['java', 'javadev'],
  },
  html: {
    publicName: 'HTML',
    twitterTags: ['html', 'webdev', 'frontenddev'],
  },
  css: {
    publicName: 'CSS',
    twitterTags: ['css', 'webdev', 'frontenddev'],
  },

  csharp: {
    publicName: 'CSharp',
    twitterTags: ['csharp'],
  },
  opensource: {
    publicName: 'Open Source',
    twitterTags: ['opensource',],
  },
  db: {
    publicName: 'Database',
    twitterTags: ['db', 'database',],
  },
  ruby: {
    publicName: 'Ruby',
    twitterTags: ['ruby',],
  },
  devops: {
    publicName: 'DevOps',
    twitterTags: ['devops',],
  },
  security: {
    publicName: 'Security',
    twitterTags: ['security',],
  },
  reactnative: {
    publicName: 'React Native',
    twitterTags: ['ReactNative',],
  },
  linux: {
    publicName: 'Linux',
    twitterTags: ['linux',],
  },  
};

class UniversalTagNames {
  getTwitterTagsByTagForNewsletter(tag) {
    const tagData = universalTagNamesDataMap[tag];
    
    return ['newsletter', ...((tagData && tagData.twitterTags) || [])];
  }

  getPublicTagName(tag) {
    const tagData = universalTagNamesDataMap[tag];

    return (tagData && tagData.publicName) || tag;
  }
}

const universalTagNamesService = new UniversalTagNames();

export default universalTagNamesService;